const PROXY = '/apps/dream-card/api/proxy';

const getClubDiscounts = async () => {
    sessionStorage.removeItem('dreamCardCustomer');
    try {
        const response = await fetch(`${PROXY}/customer/verifon-details`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
        });
        const jsonResponse = await response.json();
        if (jsonResponse.success) {
            setSessionStorage('dreamCardCustomer', jsonResponse.verifonCustomer);
        }
    } catch (error) {
        console.log(error);
    }
};

const updateVerifonCustomerType = async () => {
    const verifonCustomerType = getSessionStorage('dreamCardCustomer')?.PaymentTermsCode_Rating;
    try {
        await fetch(`${PROXY}/customer/verifon-customer-type`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
                verifonCustomerType,
            }),
        });
    } catch (error) {
        showError(errorClass, "somethingWrong");
    }
};

const setSessionStorage = (key, value) => {
    if (key) {
        sessionStorage.setItem(
            key,
            JSON.stringify(value)
        );
    }
}

const getSessionStorage = (key) => {
    return JSON.parse(sessionStorage.getItem(key));
}

function onAccountButtonClick(e) {
    e.preventDefault();
    const isLoggedIn = JSON.parse(e?.target?.dataset?.customerLoggedIn ?? null);
    if (isLoggedIn) {
        openAccountPopup();
    }
    else {
        openOtpLoginPopup(e, 'register-popup-id');
    }
}

function initAccountButton() {
    document.querySelectorAll('.boa-account-button').forEach((button) => {
        button.addEventListener('click', onAccountButtonClick);
    });
}

if (document.readyState !== 'loading') {
    initAccountButton();
} else {
    document.addEventListener('DOMContentLoaded', initAccountButton);
}
